
//# sourceMappingURL=pouchdb-selector-core.d.js.map